import React from "react";
import { Building2, ChevronDown, Layers } from "lucide-react";
import { useEstablishment } from "@/context/EstablishmentContext";
import { useLang } from "@/context/LanguageContext";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export default function EstablishmentSwitcher() {
  const { establishments, selectedId, select } = useEstablishment();
  const { t } = useLang();

  // Hide the switcher entirely for single-establishment accounts (no clutter).
  if (!establishments || establishments.length < 1) return null;

  return (
    <div className="px-4 pb-2" data-testid="establishment-switcher">
      <label className="text-[11px] font-semibold text-slate-400 uppercase tracking-wide flex items-center gap-1.5 mb-1.5">
        <Building2 size={13} /> {t("est.label")}
      </label>
      <Select value={selectedId} onValueChange={(v) => select(v)}>
        <SelectTrigger
          data-testid="establishment-select"
          className="w-full rounded-xl border border-border bg-white pl-3 pr-3 py-2.5 h-auto text-sm font-semibold text-slate-800 focus:ring-2 focus:ring-findo-indigo/30"
        >
          <span className="flex items-center gap-2 min-w-0">
            {selectedId === "all" ? <Layers size={16} className="text-slate-400 shrink-0" /> : <ChevronDown size={16} className="text-slate-400 shrink-0" />}
            <SelectValue />
          </span>
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all" data-testid="est-switch-option-all">{t("est.all").replace("{n}", establishments.length)}</SelectItem>
          {establishments.map((e) => (
            <SelectItem key={e.id} value={e.id} data-testid={`est-switch-option-${e.id}`}>
              {`${e.name}${e.is_primary ? ` · ${t("est.primary")}` : ""}`}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
